import React from "react";
import Login from "../components/LoginForm";

function LoginPage() {
  return (
    <div className="auth container">
      <Login />
    </div>
  );
}

export default LoginPage;
